import { CheckCircle2 } from "lucide-react";
import { NavLink } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="mt-16 w-full bg-primary text-primary-foreground">
            <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8">
                <div className="mb-8 grid gap-8 md:grid-cols-3">
                    <div>
                        <h2 className="mb-3 text-base font-semibold text-primary-foreground">
                            Pharmagard
                        </h2>
                        <p className="max-w-xs text-sm leading-6 text-primary-foreground">
                            Votre plateforme de référence pour trouver les
                            pharmacies de garde près de chez vous.
                        </p>
                    </div>

                    <div>
                        <h2 className="mb-3 text-base font-semibold text-primary-foreground">
                            Liens utiles
                        </h2>
                        <ul className="space-y-2 text-sm text-primary-foreground">
                            <li>
                                <a
                                    href="https://app.pharmagard.sn/contact"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-medium text-primary-foreground underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-foreground"
                                >
                                    Rejoindre le réseau
                                </a>
                            </li>
                            <li>
                                <NavLink
                                    to="/pharmacies-et-gardes"
                                    className="font-medium text-primary-foreground underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-foreground"
                                >
                                    Trouver une pharmacie
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="mb-3 text-base font-semibold text-primary-foreground">
                            Contact
                        </h2>
                        <ul className="space-y-2 text-sm text-primary-foreground">
                            <li>Email: contact@pharmagard.sn</li>
                            <li>Tél: +221 77 512 86 98</li>
                            <li>Lun-Ven: 9h - 18h</li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col gap-3 border-t border-primary-foreground/40 pt-5 text-sm text-primary-foreground sm:flex-row sm:items-center sm:justify-between">
                    <span>
                        Pharmagard — Service de garde pharmaceutique de
                        Tambacounda
                    </span>

                    <span className="inline-flex items-center gap-1.5 text-primary-foreground">
                        <CheckCircle2
                            className="h-3.5 w-3.5"
                            aria-hidden="true"
                        />
                        Informations publiques de garde
                    </span>
                </div>
            </div>
        </footer>
    );
}
